import { ButtonStateType } from '@kubit/web-ui-components/button/types';
const commonProps = (FOUNDATIONS) => ({
    display: 'flex',
    justify_content: 'center',
    align_items: 'center',
    icon: {
        height: FOUNDATIONS.size_350,
        width: FOUNDATIONS.size_350,
    },
});
export const buildSecondaryOnSurfaceIconVariant = (FOUNDATIONS) => ({
    [ButtonStateType.DEFAULT]: {
        ...commonProps(FOUNDATIONS),
        icon: {
            ...commonProps(FOUNDATIONS).icon,
            color: FOUNDATIONS.color_accent_default_secondary_icon_150,
        },
    },
    [ButtonStateType.HOVER]: {
        ...commonProps(FOUNDATIONS),
        icon: {
            ...commonProps(FOUNDATIONS).icon,
            color: FOUNDATIONS.color_accent_default_secondary_icon_150,
        },
    },
    [ButtonStateType.PRESSED]: {
        ...commonProps(FOUNDATIONS),
        icon: {
            ...commonProps(FOUNDATIONS).icon,
            color: FOUNDATIONS.color_accent_default_secondary_icon_150,
        },
    },
    [ButtonStateType.DISABLED]: {
        ...commonProps(FOUNDATIONS),
        icon: {
            ...commonProps(FOUNDATIONS).icon,
            color: FOUNDATIONS.color_accent_disabled_icon_100,
        },
    },
});
//# sourceMappingURL=secondaryOnSurface.js.map